import PropTypes from 'prop-types';

export const moldDocuments = {
  documentId: PropTypes.number,
  documentName: PropTypes.string,
  documentPath: PropTypes.string,
};
